import { requestApi } from "../axios";
const prefix = 'forum';

export function cloneProductChototApi(productId) {
    let api = `/cross-post/cloneCTProduct`;
    return requestApi(api, 'POST', {productId});
}